<template>
  <div class="ghost-button-styles">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
    </Breadcrumb>

    <CreativeGroupTags
      v-model="creativeGroupIndex"
      :groups="creativeFormGroups"
      @copy="onCreativeGroupDuplicate"
      @remove="onCreativeGroupItemRemove"
    >
      <el-button type="primary" @click="onCreativeGroupAdd">+新增</el-button>
    </CreativeGroupTags>

    <!--  组件化创意 -->
    <div v-if="creativeFormGroups.length">
      <ComponentBasedCreative
        ref="creative-form"
        :groups="creativeFormGroups"
        :creativeGroupIndex="creativeGroupIndex"
        :group.sync="creativeFormGroups[creativeGroupIndex]"
        :material-package-id="innerMaterialPackageId"
        :material-tag-list="materialTagList"
      >
      </ComponentBasedCreative>
    </div>

    <div class="submit-row">
      <el-button @click="onCreativeBackWard">上一步</el-button>
      <el-button type="primary" @click="onCreativeSubmit">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/common/js/api.js'
import { clone } from '@/common/js/just.js'
import { getTencentV3AdInfo } from '@/api/tencentada.model.js'
import { getV3UpdatePlanForm, getV3UpdateTargetingForm } from '../model/project-form.js'
import { getAllMediaTagList } from '@/api/material.model.js'
import ComponentBasedCreative from './components/creative/component-based-creative/index.vue'
import CreativeGroupTags from './components/creative/creative-group-tags.vue'

import { getV3CreativeForm } from '../model/creative-form.js'
import { SITE_ENUM } from '../model/siteset/siteset-const.js'
import { BRAND_ENUM } from '../model/creative-const.js'
import { MEDIAS } from '@/common/js/constants.js'
export default {
  components: {
    ComponentBasedCreative,
    CreativeGroupTags
  },
  provide() {
    return { creativeInstance: this }
  },
  data() {
    return {
      planForm: {},
      targetingForm: {},
      budgetForm: {},
      creativeGroupIndex: 0,
      creativeFormGroups: [],
      materialTagList: [],
      materialPackageId: 0,
      innerMaterialPackageId: 0
      // adAccounts: [{ id: 11643 }]
    }
  },

  computed: {
    adAccountId() {
      const [acc] = this.planForm.accounts || []
      return acc
    },
    hasMoment() {
      return this.planForm.siteSet?.includes(SITE_ENUM.MOMENTS) || false
    },

    currentCreativeForm() {
      return this.creativeFormGroups[this.creativeGroupIndex]
    }
  },
  methods: {
    /**
     * @description: 创意组校验、提交
     * @return {*}
     */
    async onCreativeSubmit() {
      const { projectId, accountId } = this.$route.query
      const formRefs = this.$refs['creative-form']

      // 已有计划下新增创意流程
      // 当从第三步批量配置表格返回上一步时，this.planForm.addCreativeFlag = true
      if ((projectId && accountId) || this.planForm.addCreativeFlag) {
        formRefs
          .formValidate()
          .then(() => {
            // 完成创意配置进入下一步时，生成一个是在已有计划下新增的创意组的标记
            setSession('plan_form', { ...this.planForm, addCreativeFlag: true })
            setSession('creative_groups', this.creativeFormGroups)
            setSession('targeting_groups', this.targetingForm)
            setSession('bid_form', {}) // 不需要更改，提交一个空对象即可
            this.$router.push({ name: 'tencentV3Distribute' })
          })
          .catch(this.validateErrorHandler)
      } else {
        // 批量新增计划流程
        formRefs
          .formValidate()
          .then(() => {
            setSession('creative_groups', this.creativeFormGroups)
            this.$router.push({ name: 'tencentV3Distribute' })
          })
          .catch(this.validateErrorHandler)
      }
    },
    validateErrorHandler(errorIndex) {
      if (errorIndex > -1) {
        // 跳转到对应的创意组
        this.creativeGroupIndex = errorIndex
        this.$nextTick(() => {
          const errorElement = document.querySelector('.el-form-item__error')
          errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
        })
      }
    },

    /**
     * @description: 新增空的创意组
     */
    onCreativeGroupAdd() {
      const index = this.creativeFormGroups.length + 1
      const dynamic_creative_name = `${this.planForm.project_name}_${index}`
      const creativeFormItem = getV3CreativeForm.call(this)

      // 如果不包含朋友圈，品牌形象跳转类型切换到品牌形象；不包含朋友圈不显示品牌简介页
      if (!this.hasMoment) {
        creativeFormItem.components.brand.brandType = BRAND_ENUM.BRAND
      }

      this.creativeFormGroups.push({
        ...creativeFormItem,
        dynamic_creative_name,
        groupName: `创意组${index}`
      })
      this.creativeGroupIndex = this.creativeFormGroups.length - 1
    },
    /**
     * @description: 复制当前的创意组
     */
    onCreativeGroupDuplicate(index) {
      const dupItem = { ...this.creativeFormGroups[index] }
      dupItem.groupName = `创意组${this.creativeFormGroups.length + 1}_复制`
      this.creativeFormGroups.push(clone(dupItem))
      this.creativeGroupIndex = this.creativeFormGroups.length - 1
    },
    /**
     * @description: 删除创意组
     * @param {*} index
     */
    onCreativeGroupItemRemove(index) {
      this.creativeGroupIndex = Math.max(0, index - 1)
      this.creativeFormGroups.splice(index, 1)
    },

    queryMaterialTags() {
      getAllMediaTagList({ mediaId: MEDIAS.GDT }).then((data) => {
        this.materialTagList = data
        // 将媒体素材id转换成内部的素材id
        const { tagId } = data.find((item) => item.mediaTagId === String(this.materialPackageId)) || {}
        this.innerMaterialPackageId = tagId || ''
      })
    },

    /**
     * @description: 初始化多创意组列表，默认添加一个空创意组
     * @description: 如果是从下一步返回编辑，从sessionStorage中获取数据再回显
     * @return {*}
     */
    initialCreativeFormGroups() {
      const { t } = this.$route.query
      if (t === 'edit') {
        const groups = getSession('creative_groups')
        this.creativeFormGroups = groups?.length ? groups : this.onCreativeGroupAdd()

        // 从下一步返回编辑，从sessionStorage中获取数据
        if (this.planForm.addCreativeFlag) {
          this.targetingForm = getSession('targeting_groups')
        }
      } else {
        this.onCreativeGroupAdd()
      }
      this.queryMaterialTags()
    },
    /**
     * @description: 回退上一步，提示是否保存已编辑的创意
     * @return {*}
     */
    onCreativeBackWard() {
      // 保存未编辑完的创意
      this.$confirm('当前编辑数据未保存，返回将丢失编辑数据。是否保存当前数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setSession('creative_groups', this.creativeFormGroups)
          this.$router.replace({
            name: 'tencentv3Project',
            query: {
              t: 'edit'
            }
          })
        })
        .catch(() => {
          this.$router.replace({
            name: 'tencentv3Project'
          })
        })
    },

    /**
     * @description: 在已有计划下新增创意
     * @param {*} projectId
     * @param {*} adId
     * @param {*} accountId
     */
    async initExistPlanCreativeGroups({ projectId, accountId }) {
      // 获取计划信息
      const adInfo = await getTencentV3AdInfo({ accountId, projectId })
      this.materialPackageId = adInfo.out_plan_info.material_package_id || null
      const planForm = getV3UpdatePlanForm(adInfo)

      this.targetingForm = [getV3UpdateTargetingForm.call(this, adInfo)]
      this.planForm = { ...planForm, adgroupId: adInfo.out_plan_info.adgroup_id }

      this.initialCreativeFormGroups()
    }
  },
  created() {
    const planForm = getSession('plan_form')
    const { addCreativeFlag, accounts, adgroupId } = planForm || {}
    const { projectId, accountId } = this.$route.query
    // 在已有计划上添加创意
    // 从src/views/adplan/tencentv3/components/ad-table.vue 添加创意会带入route query 参数
    // 从下一步返回，addCreativeFlag = true
    if ((projectId && accountId) || addCreativeFlag) {
      const planInfo = addCreativeFlag ? { projectId: adgroupId, accountId: accounts[0] } : { projectId, accountId }
      this.initExistPlanCreativeGroups(planInfo)
    } else {
      // 批量计划添加创意
      const { material_package_id } = getSession('bid_form') || {}

      this.planForm = planForm
      this.materialPackageId = material_package_id
      this.initialCreativeFormGroups()
    }
  }
}
</script>

<style lang="scss" scoped>
.creative-forms {
  margin-bottom: 60px;

  .selected-materials {
    .selected-images,
    .selected-videos {
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      position: relative;
    }
  }

  .upload-row {
    margin-bottom: 10px;
    display: flex;
  }

  .no-material {
    background: #f9f9f9;
    line-height: 220px;
    text-align: center;
    border-radius: 10px;
    font-size: 12px;
  }

  //创意文案
  .description-list {
    display: flex;
    align-content: center;
    margin-bottom: 6px;

    .el-icon-remove {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .components-box {
    background: #f9f9f9;
    padding: 10px 10px 30px;
    border-radius: 10px;

    ::v-deep .components-switch {
      padding-right: 10px;
      justify-content: flex-end;
      width: 130px;
    }

    .components-row {
      margin-bottom: 10px;
      display: flex;
      .label {
        padding-right: 10px;
        text-align: right;
        min-width: 130px;
        font-size: 14px;
      }
      // 同一个 el-form-item 里不需要校验的input 样式覆盖
      ::v-deep .override-not-reqiured-error input {
        border-color: #dcdfe6 !important;
      }
    }
  }
}
</style>
